import React, { useState } from 'react';

/**
 * CSS 가상 선택자(Pseudo-element)를 이용해 스크래핑을 방지하는 컴포넌트
 * Canvas 로딩 지연 및 깨짐 현상을 근본적으로 해결하면서도 DOM 파싱(긁어가기) 봇을 완벽히 차단합니다.
 */
const CanvasText = ({ text, type = 'text', style = {}, className = '', color = '#666', font }) => {
    const [isHovered, setIsHovered] = useState(false);

    if (!text) return null;

    const handleClick = () => {
        if (type === 'tel') {
            // 모바일인지 확인 (간단한 체크)
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (isMobile) {
                window.location.href = `tel:${text.replace(/-/g, '')}`;
            } else {
                handleCopy(`전화번호가 복사되었습니다: ${text}`);
            }
        } else if (type === 'email' || type === 'copy') {
            handleCopy(`${type === 'email' ? '이메일이' : '텍스트가'} 복사되었습니다: ${text}`);
        }
    };

    const handleCopy = async (message) => {
        try {
            await navigator.clipboard.writeText(text);
            alert(message);
        } catch (err) {
            console.error('Failed to copy text', err);
            const textArea = document.createElement("textarea");
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("Copy");
            textArea.remove();
            alert(message);
        }
    };

    return (
        <span
            className={`inline-block select-none before:content-[attr(data-obf)] ${className}`}
            data-obf={text}
            style={{
                ...style,
                color: color,
                font: font || 'inherit',
                cursor: type !== 'text' ? 'pointer' : 'default',
                verticalAlign: 'middle',
                opacity: isHovered && type !== 'text' ? 0.7 : 1,
                transition: 'opacity 0.2s',
                whiteSpace: 'nowrap'
            }}
            onClick={type !== 'text' ? handleClick : undefined}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            aria-label={type === 'text' ? 'Protected text' : `Push to Action: ${type}`}
            role={type !== 'text' ? 'button' : 'img'}
        />
    );
};

export default CanvasText;
